<template>
    <div>
        <router-link :to="to" tag="span">
            <button class="btn btn-primary">
                <slot></slot>
            </button>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "MainMenuButton",
        props: ['to'],
    }
</script>

<style scoped>
    .btn {
        margin: 15px auto;
        height: 60px;
        display: block;
    }
</style>
